<template>
    <Base>
        <v-card-title class="text-center d-block">
            <span class="t-color-brand-medium-base">Código de autenticação</span>
        </v-card-title>
        <v-card-text>
            <div class="t-body mb-5" v-if="type == 'email'">
                O código de autenticação foi enviado para seu e-mail.
            </div>

            <form
                :action="routeLogin"
                id="formLogin"
                method="post"
            >
                <cp-csrf-token/>
                <input type="hidden" name="code" :value="otp" />

                <v-otp-input
                    v-model="otp"
                    :disabled="saving"
                    :loading="saving"
                    required
                    @finish="onFinish"
                ></v-otp-input>

                <v-overlay absolute :value="saving">
                    <v-progress-circular
                    indeterminate
                    color="primary"
                    ></v-progress-circular>
                </v-overlay>

                <div class="d-flex justify-end mt-3">
                    <cp-button
                        color="primary"
                        type="submit"
                        :disabled="saving"
                        :loading="saving"
                        @click="onFinish"
                    >
                        Acessar
                    </cp-button>
                </div>
            </form>
        </v-card-text>
        <v-card-actions class="d-block text-right" v-if="type != 'email'">
            <v-divider></v-divider>
            <a :href="route('recovery-code.login')" class="t-hint">Acessar com código de recuperação</a>
        </v-card-actions>
    </Base>
</template>

<script>
import Base from '@components/common/Base'

export default {
    data: () => ({
        saving: false,
        otp: null,
        type: null
    }),

    metaInfo: () => ({
        title: 'Login Dois Fatores'
    }),

    components: {
        Base
    },

    created() {
        this.init();
    },

    methods: {
        init() {
            let params = this.getUrlParams()
            this.type = params.type ?? null
        },

        onFinish (rsp) {
            this.saving = true
            setTimeout(() => { document.querySelector('#formLogin').submit() }, 1000);
        },
    },

    computed: {
        routeLogin() {
            return this.type == 'email' ? this.route('two-factor.login.validate') : this.route('two-factor.login.store')
        }
    }
}
</script>